import PropTypes from 'prop-types';
import React from 'react';
import { DangerousHTMLDiv } from '../DangerousHTML/DangerousHTMLDiv';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';

export class Question extends React.Component {
  render() {
    const labelId = 'question_label_' + this.props.questionNumber;
    const requiredQuestionId = 'question_is_required_' + this.props.questionNumber;
    const invalidQuestionId = 'question_is_invalid_' + this.props.questionNumber;
    let className = this.props.isValid === false ? 'question-text color-required' : 'question-text';
    className = this.props.className ? className + ' ' + this.props.className : className;

    return (
    <div className={ className }>
      <ol start={ this.props.questionNumber }>
        <li>
          <DangerousHTMLDiv
            qaTag={ labelId }
            className="questionnaire-form-label"
            html={ this.props.formattedText }
          />
          {
            this.props.isRequired
              ? <span data-qa-item={ requiredQuestionId }
                className="fa-solid fa-asterisk color-required"
              />
              : null
          }
          {
          this.props.isMatrix ?
          this.props.isValid === false
          ? <span data-qa-item={ invalidQuestionId } className="invalid-feedback inline-block ">
              <FormattedMessage {...messages.error.required} />
            </span>
          : null
          : null
        }
        </li>
      </ol>
    </div>);
  }
}

Question.propTypes = {
  questionNumber: PropTypes.number,
  formattedText: PropTypes.string,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  className: PropTypes.string,
  isMatrix: PropTypes.bool,
};
